module.exports = __webpack_public_path__ + "media/process/Process1-866eaf5c.png";